import { Drawer, Grid, Typography } from '@mui/material';
import { FactoryOnData } from '../../pages/FactoryOn/FactoryOn';
import { InnoBizData } from '../../pages/InnoBiz/InnoBiz';
import { MainBizData } from '../../pages/MainBiz/MainBiz';
import { VentureBizData } from '../../pages/Venture/Venture';
import { AllIcxInfo } from '../../pages/IndustryLandList/IndustryLandList';
import { MiniClusterData } from '../../pages/MiniCluster/MiniCluster';

interface FactoryOnDetailDrawerProps {
  open: boolean;
  onClose: () => void;
  detailInfo?:
    | FactoryOnData
    | InnoBizData
    | MainBizData
    | VentureBizData
    | AllIcxInfo
    | MiniClusterData;
  tables: {
    title: string;
    table: Record<string, string>;
  }[];
}

const FactoryOnDetailDrawer = ({
  open,
  onClose,
  detailInfo,
  tables
}: FactoryOnDetailDrawerProps) => {
  if (!detailInfo) {
    return null;
  }

  return (
    <Drawer anchor={'right'} open={open} onClose={onClose}>
      <Grid container width={'70vh'} padding={2} gap={3}>
        <Grid container padding={2} bgcolor={'#F8F8F8'}>
          <Grid container gap={2}>
            {tables.map(({ title, table }) => (
              <Grid key={title} item xs={12} container gap={1}>
                <Typography variant="h6">{title}</Typography>
                {Object.entries(table).map(([key, value]) => {
                  const entryLabel = value;
                  const entryValue = detailInfo[key as keyof typeof detailInfo];
                  return (
                    <Entry
                      key={entryLabel}
                      label={entryLabel}
                      value={entryValue}
                    />
                  );
                })}
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Drawer>
  );
};
export default FactoryOnDetailDrawer;

const Entry = ({ label, value }: { label: string; value?: string | null }) => (
  <Grid container>
    <Grid container item xs={4} justifyContent={'flex-start'}>
      {label}
    </Grid>
    <Grid container item xs={8} justifyContent={'flex-start'}>
      {renderText(value)}
    </Grid>
  </Grid>
);

const renderText = (value?: string | null) => (!value?.length ? '-' : value);
